import React from 'react';
import { BodyText, Heading } from '@chargify/custom-ui-components';
import { Wrapper } from './Price.styles';

type Props = {
  price: string;
  intervalUnit: string;
};
export const Price = ({ intervalUnit, price }: Props) => {
  return (
    <Wrapper>
      <Heading variant={'h4'} color={'success.main'}>
        {price}
      </Heading>
      <BodyText variant={'body2'} color={'gray.dark'}>
        ({intervalUnit})
      </BodyText>
    </Wrapper>
  );
};
